// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DealsModule } from './deals/deals.module';
import { MaterialModule } from '../shared/material.module';
import { PddjLoginComponent } from './login/pddj-login.component';
import { PddjDealsComponent } from './pddj-deals/pddj-deals.component';
import { PddjRoutingModule } from './pddj-routing.module';
import { PddjUploadComponent } from './upload/pddj-upload.component';
import { PddjComponent } from './pddj.component';
import { PddjDoneComponent } from './done/pddj-done.component';
import { PddjStatusComponent } from './status/pddj-status.component';
import { SharedModule } from '../shared/shared.module';
import { DealerDashboardModule } from '../dealer-dashboard/dealer-dashboard.module';
import { PDDJHeader } from './pddj-header/pddj-header.component';
import { DealerModule } from '../dealer/dealer.module';
import { LoginModule } from '../login/login.module';
import { SplitPdfModalComponent } from './split-pdf-modal/split-pdf-modal.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@NgModule({
    declarations: [
        PddjDealsComponent,
        PddjLoginComponent,
        PddjUploadComponent,
        PddjComponent,
        PDDJHeader,
        PddjDoneComponent,
        PddjStatusComponent,
        SplitPdfModalComponent,
    ],
    imports: [
        DealerDashboardModule,
        DealerModule,
        CommonModule,
        DealsModule,
        FormsModule,
        LoginModule,
        MaterialModule,
        PddjRoutingModule,
        ReactiveFormsModule,
        RouterModule,
        SharedModule,
        PdfViewerModule,
    ],
})
export class PddjModule {}
